// Lib
import React, { ReactElement } from 'react';
import { get } from 'lodash/fp';

// Components
import LinkButton from '../../buttons/LinkButton';
import { useTranslator } from '../../i18n/useTranslator';

interface DefaultErrorFurtherDetailsProps {
    error: Error;
    furtherDetails: string;
    getErrorDetails?: (props: DefaultErrorFurtherDetailsProps) => string;
    dispatchToggleIntercom: () => void;
}

const getDefaultErrorDetails = ({ error }: DefaultErrorFurtherDetailsProps) => `Error: ${error && error.toString()}
Stack: ${get('stack', error)}`;

const DefaultErrorFurtherDetails = (props: DefaultErrorFurtherDetailsProps): ReactElement => {
    const { getErrorDetails = getDefaultErrorDetails, dispatchToggleIntercom, furtherDetails } = props;

    const textAreaRef = React.useRef<HTMLTextAreaElement | null>(null);
    const translate = useTranslator('modal', 'error.supportDetails');

    const errorDetails = getErrorDetails(props);

    const copyTextAreaToClipboard = () => {
        if (!textAreaRef.current) return;
        textAreaRef.current.select();
        document.execCommand('copy');
    };

    return (
        <details>
            <summary>{translate('summary', 'Otherwise')}</summary>
            <div className="info">
                <p className="support-message">
                    {translate(
                        'supportMessage',
                        'Please <contactSupport>contact support</contactSupport> and provide them with the following information:',
                        undefined,
                        {
                            components: {
                                contactSupport: <LinkButton onClick={dispatchToggleIntercom} />,
                            },
                        },
                    )}
                </p>
                {furtherDetails}
                <button className="clipboard" onClick={copyTextAreaToClipboard}>
                    {translate('copyButton', 'Copy to clipboard')}
                </button>
                <div>
                    <textarea
                        ref={textAreaRef}
                        readOnly
                        value={errorDetails}
                        onFocus={copyTextAreaToClipboard}
                        onClick={copyTextAreaToClipboard}
                    />
                </div>
            </div>
        </details>
    );
};

export default DefaultErrorFurtherDetails;
